import { Button, Dropdown, InputNumber, Slider } from "antd";
import { useState } from "react";
import { CloseRange, DropdownIcon } from "themes/Icon";
import ButtonComp from "../Button";
import "./range_filter.scss";

const RangeFilter = ({
  tempRange,
  setTempRange,
  setRange,
  range,
  filterUserCount,
  setFilterUserCount = () => {},
}) => {
  const [open, setOpen] = useState(false); // Dropdown state

  const handleSliderChange = (value) => {
    setTempRange(value);
  };

  // Handle min input change
  const handleMinChange = (value) => {
    setTempRange([value, tempRange[1]]);
  };

  // Handle max input change
  const handleMaxChange = (value) => {
    setTempRange([tempRange[0], value]);
  };

  // Apply selected range
  const handleApply = () => {
    setFilterUserCount(tempRange);
    setRange(tempRange); // Save selection
    setOpen(false); // Close dropdown
  };

  // Clear selected range
  const handleClear = (e) => {
    setTempRange([0, 100]);
    setFilterUserCount(null);
    e.stopPropagation(); // Prevent dropdown from opening when clicking "X"
    setRange(null); // Reset selected range to default
  };

  // Handle dropdown open/close
  const handleOpenChange = (isOpen) => {
    if (!isOpen) {
      setTempRange(range || [0, 100]); // Reset temp range to last applied range when closing
    }
    setOpen(isOpen);
  };

  // Dropdown content
  const menu = (
    <div className="range-filter-content">
      <div className="flex align-center ">
        <div className="flex gap-1 flex-column w-full">
          <label htmlFor="min-input">Min</label>
          <div className="flex align-center">
            <InputNumber
              className="number-input-comp"
              id="min-input"
              min={0}
              max={tempRange[1]}
              value={tempRange[0]}
              onChange={handleMinChange}
            />
            <span className="input-separator"></span>
          </div>
        </div>
        <div className="flex gap-1 flex-column w-full">
          <label htmlFor="max-input">Max</label>
          <InputNumber
            className="number-input-comp"
            id="max-input"
            min={tempRange[0]}
            max={100}
            value={tempRange[1]}
            onChange={handleMaxChange}
          />
        </div>
      </div>
      <Slider
        className="slider-comp"
        range
        min={0}
        max={100}
        value={tempRange}
        onChange={handleSliderChange}
        marks={{
          0: "0",
          100: "100",
        }}
      />
      <ButtonComp onClick={handleApply} wFull>
        Apply
      </ButtonComp>
    </div>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={["click"]}
      open={open}
      onOpenChange={handleOpenChange}
      className="range-filter-dropdown"
    >
      <Button>
        <span>{range && range[1] ? `${range[0]} - ${range[1]}` : "Range"}</span>
        {filterUserCount && (
          <span onClick={handleClear} className="close-icon">
            {range && range[0] ? <CloseRange className="close" /> : null}
          </span>
        )}
        <DropdownIcon />
      </Button>
    </Dropdown>
  );
};

export default RangeFilter;
